<template>
  <Modal variant="maintenance" notClose>
    <template slot="lead">
      <div class="c-image--radius">
        <img src="@/assets/img/img-chara-maintenance.svg" alt="" width="70" />
      </div>
      {{ maintenance.summary }}
    </template>
    <template slot="content">
      <div class="c-text--free" :style="{ height: contentOuterH + 'px' }">
        <perfect-scrollbar>
          <div v-html="maintenance.description" ref="content"></div>
        </perfect-scrollbar>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/Modal';
import { PerfectScrollbar } from 'vue2-perfect-scrollbar';

export default {
  components: {
    Modal,
    PerfectScrollbar
  },

  data() {
    return {
      contentOuterH: 0,
      contentMaxH: 214
    };
  },

  computed: {
    maintenance() {
      return this.$store.getters['view/maintenance'];
    }
  },

  watch: {
    maintenance: {
      handler() {
        this.setHeight();
      },
      immediate: true
    }
  },

  methods: {
    setHeight() {
      this.$nextTick(() => {
        if (!this.$refs.content) {
          return;
        }
        let contentH = this.$refs.content.clientHeight;
        this.contentOuterH = Math.min(contentH, this.contentMaxH);
      });
    }
  }
};
</script>
